/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Report-chart2': {
    width: 16,
    height: 14,
    viewBox: '0 0 16 14',
    data: '<path pid="0" d="M4.6 13.666H.446V4.6h4.156v9.066zM10.08.066H5.923v13.6h4.156V.066zm5.477 6.045h-4.155v7.555h4.155V6.111z" _fill="#00204D"/>'
  }
})
